import { render, staticRenderFns } from "./GenericMenu.vue?vue&type=template&id=5c41e91b&scoped=true"
import script from "./GenericMenu.vue?vue&type=script&lang=js"
export * from "./GenericMenu.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/GenericMenu/GenericMenu.less?vue&type=style&index=0&id=5c41e91b&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c41e91b",
  null
  
)

export default component.exports